import * as React from "react";
import {Fragment} from "react";
import Item from "./Item";
import KeySolver from "../../../KeySolver";

class Navigation extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {items} = this.props;

		return (
			<Fragment>
				{items &&
					<Fragment>
						{items.map((item, i) =>
							<Fragment key={KeySolver()} >
								<Item label={item.properties.title} icon={item.properties.icon} target={'item_' + item.identifier} selected={parseInt(i) === 0} />
							</Fragment>
						)}
					</Fragment>
				}
			</Fragment>
		);
	}
}

export default Navigation;
